import React, { useState, useEffect } from 'react';
import styles from './TemplateHero8.module.css';

const TemplateHero8 = ({ branding, heroData }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Safely extract slides
  const slides = heroData?.slides || [];

  // Auto-play slider logic (Strictly following the established pattern)
  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Hide component safely if no data is present
  if (slides.length === 0) return null;

  return (
    <div className={styles.heroContainer}>
      {/* Background Slides */}
      <div className={styles.bgLayer}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`${styles.slide} ${index === currentSlide ? styles.activeSlide : ''}`}
            style={{ backgroundImage: `url('${slide.image}')` }}
          >
            <div className={styles.darkenOverlay}></div>
          </div>
        ))}
      </div>

      <div className={styles.mainLayout}>
        {/* Left Side: Floating Image Card */}
        <div className={styles.imageSection}>
          <div className={styles.cardFrame} key={`frame-${currentSlide}`}>
            <div 
              className={styles.floatingImage} 
              style={{ backgroundImage: `url('${slides[currentSlide].image}')` }}
            ></div>
          </div>
        </div>

        {/* Right Side: Typography Content */}
        <div className={styles.contentSection}>
          <div className={styles.contentBox} key={`text-${currentSlide}`}>
            <div className={styles.divider}></div>
            <h1 className={styles.title}>
              {slides[currentSlide].title}
            </h1>
            <p className={styles.subtitle}>
              {slides[currentSlide].subtitle}
            </p>
            <div className={styles.actions}>
              <button className={styles.btnPrimary}>
                Book Experience
              </button>
              <button className={styles.btnLink}>
                Explore Gallery
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Vertical Pagination Bars */}
      {slides.length > 1 && (
        <div className={styles.pagination}>
          {slides.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`${styles.pagItem} ${index === currentSlide ? styles.pagActive : ''}`}
            >
              <span className={styles.pagLabel}>Step 0{index + 1}</span>
              <div className={styles.pagBar}></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplateHero8;